export function Logo({ className = "", markColor = "#163A5F", showText = true, textColor = "#163A5F" }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <svg width="34" height="34" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        {/* House */}
        <path d="M32 6L58 26v2H50v30H14V28H6v-2L32 6z" fill={markColor} />
        {/* Interior notch (white) */}
        <path d="M32 15l16 12v25H16V27L32 15z" fill="#fff" />
        {/* Paint roller */}
        <rect x="21" y="24" width="22" height="7" rx="1.5" fill={markColor} />
        <rect x="41" y="26.5" width="6" height="2" fill={markColor} />
        <path d="M44 27.5v6" stroke={markColor} strokeWidth="2" strokeLinecap="round" />
        {/* Trowel */}
        <path d="M25 38h14l-7 11-7-11z" fill="#F28C28" />
        <rect x="30.5" y="33" width="3" height="6" rx="1" fill={markColor} />
      </svg>
      {showText && (
        <span className="font-display font-extrabold leading-none tracking-tight" style={{ color: textColor }}>
          <span className="block text-[15px] sm:text-base">Muratore</span>
          <span className="block text-[15px] sm:text-base -mt-0.5">Imbianchino</span>
        </span>
      )}
    </span>
  );
}

export function WhatsAppIcon({ size = 20, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zM12.05 21.785h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.889-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884zM20.52 3.449C18.24 1.245 15.24 0 12.045 0 5.463 0 .104 5.334.101 11.892c0 2.096.549 4.14 1.595 5.945L0 24l6.305-1.654a11.98 11.98 0 005.734 1.459h.005c6.582 0 11.946-5.335 11.949-11.893a11.821 11.821 0 00-3.473-8.463z"/>
    </svg>
  );
}
